export default {
  namespaced: true,
  state: {
    isStudentCloseModal: false,

    showModalCustomerFeedback: false,
    showCfeForm: false,
    showCfeConfirmation: false,
    showCfeHideTrainerModal: false,
    customerFeedbackSetting: null,

    showChatMessageHistory: false,
    showChatMessageEdit: false,

    showPostAssessmentPromotion: false,
    promotionData: null,
    promotionFetchStatus: 'idle',
    promotionFetchAttempted: false,
  },
  getters: {
    isModalShowing: (state) => {
      return state.showModalCustomerFeedback;
    },
    isCustomerFeedbackModalEnabled: (state) => {
      return !state.customerFeedbackSetting?.is_disabled && state.customerFeedbackSetting?.is_due_for_display;
    },
    isPromotionAvailable: (state) => {
      return state.promotionData?.is_enabled &&
             state.promotionData?.banners?.length > 0;
    }
  },
  mutations: {
    setIsStudentCloseModal(state, payload) {
      state.isStudentCloseModal = payload;
    },
    setShowModalCustomerFeedback(state, payload) {
      state.showModalCustomerFeedback = payload;
    },
    setCustomerFeedbackSetting(state, payload) {
      state.customerFeedbackSetting = payload;
    },
    setShowCfeForm(state, payload) {
      state.showCfeForm = payload;
    },
    setShowCfeConfirmation(state, payload) {
      state.showCfeConfirmation = payload;
    },
    setShowCfeHideTrainerModal(state, payload) {
      state.showCfeHideTrainerModal = payload;
    },
    setShowMessageHistory(state, payload) {
      state.showChatMessageHistory = payload;
    },
    setShowMessageEdit(state, payload) {
      state.showChatMessageEdit = payload;
    },
    setAllModal(state, payload) {
      state.showModalCustomerFeedback = payload;
    },
    setShowPostAssessmentPromotion(state, payload) {
      state.showPostAssessmentPromotion = payload;
    },
    setPromotionData(state, payload) {
      state.promotionData = payload;
    },
    setPromotionFetchStatus(state, payload) {
      state.promotionFetchStatus = payload;
    },
    setPromotionFetchAttempted(state, payload) {
      state.promotionFetchAttempted = payload;
    },
    resetPromotionState(state) {
      state.showPostAssessmentPromotion = false;
      state.promotionData = null;
      state.promotionFetchStatus = 'idle';
      state.promotionFetchAttempted = false;
    }
  },
  actions: {}
};
